import { Injectable } from '@angular/core';
import { NavigationExtras, Router, UrlTree } from '@angular/router';
import { LocationStrategy } from '@angular/common';
import { safeReturnUrl } from '../utils/return-url.util';

@Injectable({
    providedIn: 'root',
})
export class RoutingService {
    private _location: LocationStrategy;
    private _router: Router;

    constructor(_location: LocationStrategy, _router: Router) {
        this._location = _location;
        this._router = _router;
    }

    public getCurrentPath() {
        return this._location.path();
    }

    /**
     *
     */
    public redirectToLogin() {
        // Where they were, so login can send them back.
        //
        // This used to build `['/auth/login', { uri }]`, which is a MATRIX
        // parameter -- `/auth/login;uri=...` -- and lands in `route.params`.
        // The login page reads `uri` off `queryParams`, so it never saw one and
        // every redirect here quietly lost the user's destination. Sent as a
        // real query parameter, the round trip works (RF-3066).
        const uri = safeReturnUrl(this.getCurrentPath());

        //noinspection JSIgnoredPromiseFromCall
        // Raw, not pre-encoded: Angular encodes query values itself.
        this._router.navigate(
            ['/auth/login'],
            uri ? { queryParams: { uri } } : {},
        );
    }

    public navigate(
        commands: any[],
        extras?: NavigationExtras,
    ): Promise<boolean> {
        return this._router.navigate(commands, extras);
    }

    public navigateByUrl(
        url: string | UrlTree,
        extras?: NavigationExtras,
    ): Promise<boolean> {
        return this._router.navigateByUrl(url, extras);
    }
}
